import React from 'react';
const bonuses = [{
  title: 'IL KIT DI PARTENZA DANZA READY™',
  description: 'Tutto ciò che serve per far iniziare le allieve subito, senza confusione e senza perdere tempo.'
}, {
  title: 'LA CHECKLIST ANTI-VERGOGNA™',
  description: 'Una guida emozionale per aiutare le allieve a superare blocchi mentali, insicurezza e paura del giudizio.'
}, {
  title: 'IL PLANNER 21 GIORNI DI COSTANZA™',
  description: 'Il sistema di pianificazione visiva per seguire il metodo senza mollare a metà percorso.'
}, {
  title: 'LA GUIDA EXPRESS ALLA MUSICA GIUSTA™',
  description: "Come scegliere la musica ideale per ogni sessione e trasformare ogni pratica in un'esperienza coinvolgente."
}, {
  title: 'IL RITUALE POST-DANZA DI 7 MINUTI™',
  description: 'La routine di chiusura perfetta per terminare ogni sessione sentendosi leggera, rilassata e motivata a tornare.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Risparmia Ore Ogni Settimana',
  desc: 'Smetti di creare sessioni da zero. Apri il sistema, scegli il framework e inizia a insegnare immediatamente.'
}, {
  emoji: '👑',
  title: 'Maggiore Fiducia nel Coaching',
  desc: 'Saprai esattamente cosa insegnare, quando far progredire le allieve e come strutturare i programmi per ottenere risultati reali.'
}, {
  emoji: '🩰',
  title: 'Risultati Migliori per le Allieve',
  desc: 'Offri sistemi di allenamento strutturati che migliorano la performance, la costanza e la trasformazione corporea.'
}, {
  emoji: '😊',
  title: 'Maggiore Fidelizzazione delle Allieve',
  desc: 'Mantieni le tue allieve motivate attraverso progressioni chiare, sistemi di coaching professionali e miglioramenti visibili nel tempo.'
}];
export function BonusSection() {
  return <>
      <section className="py-6 px-4 sm:px-6 bg-brand-cream" data-id="element-15">
        <div className="text-center mb-4" data-id="element-16">
          <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-17">
            5 BONUS PREMIUM INCLUSI
          </h2>
          <p className="text-sm text-brand-taupe font-medium leading-tight" data-id="element-18">
            Riceverai anche 5 bonus premium progettati per farti risparmiare
            ancora più tempo e aiutare le tue allieve a ottenere risultati
            migliori.
          </p>
        </div>

        <div className="flex flex-col gap-2 mb-4" data-id="element-19">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 p-3 rounded text-center shadow-sm" data-id="element-20">
              <p className="text-[11px] font-button font-bold text-brand-gold mb-0.5 tracking-wider uppercase" data-id="element-21">
                🎁 BONUS {i + 1} — GRATIS
              </p>
              <h3 className="text-sm font-bold text-brand-taupe mb-1 leading-tight uppercase" data-id="element-22">
                {bonus.title}
              </h3>
              <p className="text-xs text-brand-taupe/80 font-medium leading-tight" data-id="element-23">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <p className="text-center font-button font-bold text-brand-rose text-sm uppercase tracking-wide bg-brand-rose/10 py-2 rounded" data-id="element-24">
          I 5 bonus sono GRATIS con il tuo acquisto di oggi.
        </p>
      </section>

      <section className="py-6 px-4 sm:px-6 bg-white border-t-4 border-brand-beige" data-id="element-25">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-taupe mb-4 uppercase leading-tight" data-id="element-26">
          COSA CAMBIERÀ
        </h2>

        <div className="flex flex-col gap-2" data-id="element-27">
          {benefits.map((item, i) => <div key={i} className="bg-brand-cream border-l-4 border-brand-rose p-3 rounded-r shadow-sm flex gap-3 items-start" data-id="element-28">
              <div className="text-xl shrink-0 leading-none" data-id="element-29">{item.emoji}</div>
              <div data-id="element-30">
                <h3 className="text-sm font-bold text-brand-taupe mb-0.5 uppercase tracking-tight" data-id="element-31">
                  {item.title}
                </h3>
                <p className="text-brand-taupe/80 text-xs font-medium leading-tight" data-id="element-32">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}